import classnames from 'classnames/bind'
import React from 'react'
import { useTranslate } from 'react-polyglot'

import FakeArrowLink from '~/components/FakeArrowLink'
import ImageWithPlaceholder, {
  ImageWithPlaceholderProps,
} from '~/components/ImageWithPlaceholder'
import Link, { LinkProps } from '~/components/Link'
import Ratio from '~/components/Ratio'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface BoxDocumentProps {
  className?: string
  image?: ImageWithPlaceholderProps
  title?: RichTextBlock[]
  text?: RichTextBlock[]
  link?: LinkProps
}

function BoxDocument({
  className,
  image,
  title,
  text,
  link,
}: BoxDocumentProps) {
  const t = useTranslate()

  const titleStyle = useStyle({ textPreset: 'title-section' })
  const textStyle = useStyle({ textPreset: 'text-paragraph' })

  return (
    <Link {...link} className={cx(css.BoxDocument, className)}>
      <div className={css.imageContainer}>
        {image && (
          <Ratio
            ratio={356 / 224}
            className={cx(css.imageWrapper, css.hideOnSmallScreen)}>
            {(cn) => (
              <ImageWithPlaceholder
                layout="fill"
                objectFit="cover"
                className={css.image}
                {...image}
              />
            )}
          </Ratio>
        )}
        {image && (
          <Ratio
            ratio={343 / 180}
            className={cx(css.imageWrapper, css.hideOnLargeScreen)}>
            {(cn) => (
              <ImageWithPlaceholder
                layout="fill"
                objectFit="cover"
                className={css.image}
                {...image}
              />
            )}
          </Ratio>
        )}
      </div>
      <div className={css.boxContent}>
        {title && (
          <RichText className={cx(titleStyle, css.title)} render={title} />
        )}
        {text && <RichText className={cx(textStyle, css.text)} render={text} />}
        <FakeArrowLink className={css.cta}>
          <span>{t('article.read_more')}</span>
        </FakeArrowLink>
      </div>
    </Link>
  )
}

BoxDocument.defaultProps = {}

export default BoxDocument
